<template>
  <a-modal v-model="visible" :width="640" :title="`${sourceId === null ? '创建' : '编辑'}数据修正`" @cancel="close('cancel')" @ok="onSubmit">
    <a-form-model ref="form" :rules="rules" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="类型" prop="source_type">
        <a-select v-model="form.source_type" style="width: 100%" @change="handleChange">
          <a-select-option value="requirement"> 需求 </a-select-option>
          <a-select-option value="issue"> 缺陷 </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.source_type === 'requirement'" label="需求" prop="source_type">
        <a-select v-model="form.source_value" show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="searching ? undefined : null" @search="searchStory">
          <a-spin v-if="searching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-else label="缺陷" prop="source_type">
        <a-select v-model="form.source_value" show-search label-in-value style="width: 100%" :filter-option="false" :not-found-content="searching ? undefined : null" @search="searchIssue">
          <a-spin v-if="searching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in searchIssueData" :key="item.value" :value="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="修正项" prop="items">
        <a-checkbox-group v-if="form.source_type === 'requirement'" v-model="form.items" :options="[{ label: '完成时间', value: 'completed_time' }]" />
        <a-checkbox-group
          v-else
          v-model="form.items"
          :options="[
            { label: '解决时间', value: 'resolved_time' },
            { label: '解决人', value: 'solver' }
          ]"
          @change="onChange"
        />
      </a-form-model-item>
      <a-form-model-item v-if="form.items.includes('resolved_time')" label="解决时间" prop="resolved_time">
        <a-date-picker v-model="form.resolved_time" show-time placeholder="解决时间" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss" />
      </a-form-model-item>
      <a-form-model-item v-if="form.items.includes('completed_time')" label="完成时间" prop="completed_time">
        <a-date-picker v-model="form.completed_time" show-time placeholder="完成时间" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss" />
      </a-form-model-item>
      <a-form-model-item v-if="form.items.includes('solver')" label="解决人" prop="solver">
        <a-select v-model="form.solver" show-search placeholder="负责人" :filter-option="utils.filterOption">
          <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="备注信息">
        <a-input v-model="form.description" type="textarea" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { userList } from '@/api/system/auth';
import { issueList } from '@/api/project/issue';
import { storySearch } from '@/api/project/story';
import { dataCorrectionAdd, dataCorrectionModify } from '@/api/data/noticeboard';
export default {
  props: {
    display: {
      type: Boolean,
      default: false
    },
    sourceId: {
      type: [String, Number],
      default: null
    },
    sourceData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        title: null,
        description: null,
        items: [],
        source_type: 'requirement',
        source_value: {}
      },
      searching: false,
      userData: [],
      searchStoryData: [],
      searchIssueData: [],
      rules: {
        source_type: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        items: [{ required: true, message: '修正项不能为空', trigger: 'blur' }],
        source_id: [{ required: true, message: '不能为空', trigger: 'blur' }],
        resolved_time: [{ required: true, message: '解决时间不能为空', trigger: 'blur' }],
        completed_time: [{ required: true, message: '完成时间不能为空', trigger: 'blur' }],
        solver: [{ required: true, message: '解决人不能为空', trigger: 'blur' }]
      },
      contentForm: []
    };
  },
  watch: {
    display() {
      this.visible = this.display;
      if (this.visible === true) {
        this.getUserList();
        if (this.sourceId !== null) {
          this.form = this.sourceData;
        } else {
          this.form = { title: null, description: null, source_type: 'requirement', source_value: {}, items: [] };
        }
      }
    }
  },
  methods: {
    close(type) {
      this.$emit('close', type);
    },

    // 获取用户列表
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },

    // 需求搜索
    searchStory(value) {
      storySearch({ value: value }).then(res => {
        this.searchStoryData = res.data.items;
      });
    },

    // 缺陷搜索
    searchIssue(value) {
      issueList({ title: value, page_size: 10, page_number: 1 }).then(res => {
        this.searchIssueData = res.data.items.map(item => {
          return {
            id: item.id,
            title: item.title,
            lable: item.title,
            value: item.id
          };
        });
      });
    },

    handleChange() {
      this.form.source_value = {};
      this.form.items = [];
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const request = {
            source_id: this.form.source_value.key,
            source_type: this.form.source_type,
            description: this.form.description,
            content: {}
          };
          const content = {};
          this.form.items.forEach(item => {
            this.$set(content, item, this.form[item]);
          });
          request.content = content;
          if (this.sourceId === null) {
            dataCorrectionAdd(request)
              .then(() => {
                this.close('submit');
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            dataCorrectionModify({ id: this.sourceId, ...request })
              .then(() => {
                this.close('submit');
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
